// extracted by mini-css-extract-plugin
module.exports = {"dataRangeNeedfast":"data-range-needfast___1fkKe","dataRangeNeedfastFlex":"data-range-needfast-flex___3ZeWc","customizeDataRange":"customize-data-range___2a87f"};